import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { useDeleteInventoryBoxQr } from "../../../apis";
import { DeleteInventoryBoxQrModalProps } from "./DeleteInventoryBoxQrModal.types";

import styles from "./DeleteInventoryBoxQrModal.module.scss";

const DeleteInventoryBoxQrModal = ({
  isOpen,
  id,
  onClose,
  onDeleteSuccess
}: DeleteInventoryBoxQrModalProps) => {
  const { t } = useTranslation();

  const {
    isLoading: isLoadingDeleteInventoryBoxQr,
    mutate: mutateDeleteInventoryBoxQr
  } = useDeleteInventoryBoxQr({
    onSuccess: () => {
      onClose();
      onDeleteSuccess();
      toast.success(t("QR deleted successfully"));
    }
  });

  const onDeleteInventoryBoxQr = () => {
    mutateDeleteInventoryBoxQr(id);
  };

  return (
    <Modal
      type="delete"
      isOpen={isOpen}
      title={`${t("Delete box")}`}
      isLoading={isLoadingDeleteInventoryBoxQr}
      okText={`${t("Delete")}`}
      onOk={onDeleteInventoryBoxQr}
      contentClassName={styles.deleteQrModal}
      onClose={onClose}
    >
      <p className={styles.deleteQrModal_text}>
        {`${t("Deleting this box will be irreversible.")}`}
        <br />
        {`${t("Are you sure you want to continue?")}`}
      </p>
    </Modal>
  );
};

export default DeleteInventoryBoxQrModal;
